// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2kSZI","ranges":"BmiRanges_ranges__3eS50"};